export function parseShowPageModule(module) {
	const state = {};

	state.title = module.gist.title;
	state.id = module.gist.id;
	state.contentType = module.gist.contentType;
	state.image = module.gist.videoImageUrl;
	state.description = module.gist.description;
	state.videos = (module.seasons[0] && module.seasons[0].episodes.filter(v => v.gist.id != null)) || [];
	state.instructors = (module.gist.persons && module.gist.persons.map(i => i.gist)) || [];

	return state;
}